import '@/app/app.css';
import './comparison.css';

import '@/app/app';
import '@/layouts/main/main';

import {SliderProducts} from '@/features/slider-products/slider-products';
import {ProductBlock} from '@/features/product-block/product-block';
import {ComparisonContent} from '@/features/comparison/comparison-content/comparison-content';

window.app.ComparisonContent = ComparisonContent;
window.app.ProductBlock = ProductBlock;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
	document.querySelectorAll('.js-comparison-content').forEach((element) => new ComparisonContent(element));
});
